import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import Ps from 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import classNames from 'classnames';
export default class WindowBox extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const {
      isOverflow,
    } = this.props;
    if (isOverflow) {
      Ps.initialize(this.refs.window);
    }
  }
  componentWillUnmount() {
    const {
      isOverflow,
    } = this.props;
    if (isOverflow) {
      Ps.initialize(this.refs.window);
    }
  }
  render() {
    const {
      title,
      onClose,
      width,
      height,
      isOverflow,
      winTitleClass,
      isShowCloseBtn,
    } = this.props;
    return (
      <div className="window-container">
        <div
          className={classNames('window', { 'window_overflow': isOverflow })}
          ref="window"
          style={
            {
              width: width ? width : 600,
              height: height ? height : 'auto',
            }
          }
        >
          <div className={winTitleClass ? winTitleClass : 'window-title'}>
            <h1>{title}</h1>
            {
              isShowCloseBtn &&
              <button className="btn window-title-button" onClick={onClose}>
                <span className="fa-stack fa-lg">
                  <i className="fa fa-circle fa-stack-1x fa-inverse window_inverse" style={{ fontSize: '1.2em' }}></i>
                  <i className="fa fa-circle fa-stack-1x" style={{ color: '#8ABFE5' }}></i>
                  <i className="fa fa-times fa-stack-1x" style={{ color: '#157FCC', fontSize: '0.59em' }}></i>
                </span>
              </button>
            }
          </div>
          <div className="new-window-body">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

WindowBox.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  winTitleClass: PropTypes.string,
  children: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  isOverflow: PropTypes.bool,
  isShowCloseBtn: PropTypes.bool,
};
WindowBox.defaultProps = {
  isOverflow: false,
  isShowCloseBtn: true,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/components/WindowBox/index.js
 **/